module.exports = __webpack_public_path__ + "img/9788970138626.18b52d0d.jpg";